// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"510":"route-flexible","808":"route-admin","7009":"route-routes","8145":"route-specific","8994":"route-priceAlerts"}[chunkId] + "." + {"510":"cc957b8c","808":"2ad261dc","7009":"49b6e068","8145":"dbd2ea8b","8994":"2ad261dc"}[chunkId] + ".css";
};